import React from "react";
import { MotifFormField } from "@ey-xd/motif-react";
import minusIcon from "../../assets/images/minus_img.svg";
import incrementIcon from "../../assets/images/increment_img.svg";

interface NumericInputProps {
  id: string;
  value: string | number;
  error?: string;
  min?: number;
  max?: number;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: any) => void;
  label?: string;
  inputType?: "quantity" | "duration";
  onDecrementAtOne?: () => void;
}

const NumericInput: React.FC<NumericInputProps> = ({
  id,
  value,
  error,
  min,
  max,
  placeholder = "",
  disabled = false,
  onChange,
  onDecrementAtOne,
  label,
  inputType = "duration",
}) => {
  let customError = "";
  const numericValue = Number(value);
  // Only validate min/max if value is not empty
  if (value !== "" && value !== undefined && value !== null) {
    if (max !== undefined && numericValue > max) {
      customError = `Max value is ${max}`;
    } else if (min !== undefined && numericValue < min) {
      customError = `Min value is ${min}`;
    }
  }

  const displayError = !disabled && (error || customError);

  return (
    <>
      <MotifFormField aria-labelledby={`duration-label-${id}`} role="group">
        <div className="motif-wrapper-numeric" data-motif-numeric-input="true">
          <div className="motif-input-component" data-motif-input="true">
            <input
              id={`duration-input-${id}`}
              className={
                displayError
                  ? `product-detail-${inputType}-input input-error`
                  : `product-detail-${inputType}-input motif-input111 motif-input-has-value motif-numeric-input`
              }
              placeholder={placeholder}
              type="text"
              min={min}
              max={max}
              value={value}
              onChange={(event) => {
                const val = event.target.value.replace(/[^0-9]/g, "");
                onChange(val);
              }}
              aria-label={label || "duration"}
              disabled={disabled}
              pattern="[0-9]*"
              inputMode="numeric"
            />
            <div
              className="motif-input-right-components"
              data-motif-input-right-components="true"
            ></div>
          </div>
          <button
            aria-disabled={disabled}
            aria-label="decrease value"
            type="button"
            className="motif-button motif-button-primary-alt motif-button-small motif-button-icon-only motif-numeric-button"
            onClick={() => {
              if (
                inputType === "quantity" &&
                Number(value) === 1 &&
                onDecrementAtOne
              ) {
                onDecrementAtOne();
                return;
              }

              onChange(
                String(
                  Math.max(Number(value) - 1, min ?? Number.NEGATIVE_INFINITY),
                ),
              );
            }}
            disabled={
              disabled || (min !== undefined ? Number(value) <= min : false)
            }
          >
            <span className="motif-icon" title="" data-motif-icon="true">
              <img src={minusIcon} alt="decrement" className="motif-svg-icon" />
            </span>
          </button>
          <button
            aria-disabled={disabled}
            aria-label="increase value"
            type="button"
            className="motif-button motif-button-primary-alt motif-button-small motif-button-icon-only motif-numeric-button"
            onClick={() =>
              onChange(
                String(
                  Math.min(Number(value) + 1, max ?? Number.POSITIVE_INFINITY),
                ),
              )
            }
            disabled={
              disabled || (max !== undefined ? Number(value) >= max : false)
            }
          >
            <span className="motif-icon" title="" data-motif-icon="true">
              <img
                src={incrementIcon}
                alt="increment"
                className="motif-svg-icon"
              />
            </span>
          </button>
        </div>
      </MotifFormField>
      {displayError && <div className="error-message">{displayError}</div>}
    </>
  );
};

export default NumericInput;
